import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

pageBusiness()
function pageBusiness() {
  if (!document.getElementById('page-business')) {
    return
  }

  let bizListSwiper
  if (document.getElementById('bizList')) {
    // SP時だけスライダーにする
    if (window.matchMedia('(max-width:768px)').matches) {
      bizListSwiperInit()
    }
    window.addEventListener('resize', function (e) {
      if (bizListSwiper && window.matchMedia('(min-width:769px)').matches) {
        bizListSwiper.destroy()
        bizListSwiper = false
      } else if (!bizListSwiper && window.matchMedia('(max-width:768px)').matches) {
        bizListSwiperInit()
      }
    })
  }
  function bizListSwiperInit() {
    const slideItem = document.getElementById('bizList')
    const sliderName = 'bizList'
    bizListSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（bizListSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1.3, //表示数変更
      centeredSlides: true, // 中央のスライドを基準にする
      spaceBetween: 10, //スライド同士の間隔を空ける
      slideToClickedSlide: true, // クリックしたスライドをアクティブにする

      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }
}
